import type { Team, User } from '@/api/types'
import type { Person } from '@/views/model'

// `팀 관리` 의 산수(F-66). 화면은 이 값들만 그리고, 후보를 걸러 내지 않는다 —
// 소속이 목록의 길이를 정하면 "분명 있는데 없다고 한다" 가 되기 때문이다(#370).

/** 대상이 될 수 있는 사람. `teams` 는 그 사람의 **모든** 소속이다. */
export type Candidate = Person

export type Verb = 'add' | 'remove'
export type Pair = { user: User; team: Team }

/**
 * 부를 짝. 넣기는 **아직 안 든 짝**만이고 빼기는 **이미 든 짝**만이다.
 *
 * `PUT` 은 멱등이지만 아무 일도 하지 않는 멱등이 아니다 — 본문의 역할이 그 사람의 최종 역할이 되는
 * upsert 라, 이미 소유자인 사람에게 `member` 를 보내면 **강등**이다(#375). 넣기는 없는 사람을
 * 넣는 것이지 역할을 덮어쓰는 것이 아니다. `DELETE` 는 비멤버에게 404 라 든 사람에게만 보낸다.
 */
export function pairs(verb: Verb, chosen: Candidate[], teams: Team[]): Pair[] {
  return teams.flatMap((team) =>
    chosen
      .filter((c) => c.teams.some((t) => t.team.id === team.id) === (verb === 'remove'))
      .map((c) => ({ user: c.user, team })),
  )
}
